<template>
  <main id="main" class="main-site">
    <div class="container">
      <div class="main-content-area">
        <div class="row">
          <div class="col-md-12">
            <h3 class="box-title">Carrinho Fechado</h3>
          </div>
        </div>
        <div style="margin: auto;">
          <figure>
            <a :href="`${$SiteUrl}/loja`" title="Loja - Aldo Solar">
              <img src="/assets/images/banner-carrinho-fechado.jpg" alt="Carrinho Fechado">
            </a>
          </figure>
        </div>
      </div>
    </div>
  </main>
</template>
<script>

export default {
  name: "ClosedKombi",
  mounted(){
    if (localStorage.buyDataLayer) {
      let lastBuy = JSON.parse(localStorage.buyDataLayer);
      this.$gtm.push(lastBuy);
      localStorage.removeItem('buyDataLayer');
    }
  }
};
</script>
